var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _text, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 567.18 338.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#7c2a8c;}.cls-3{fill:#687c86;}.cls-4{fill:#010101;}.cls-5,.cls-7{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{stroke:#ffcc04;}.cls-6{font-size:8px;fill:#231f20;font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}.cls-7{stroke:#6b7b84;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 497.6,
    y1: 295.18,
    x2: 555.01,
    y2: 295.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d41182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81298e"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "555.01 319.09 526.3 271.26 497.61 319.09 555.01 319.09"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.56,301l-.65.09a1.85,1.85,0,0,1-.32.08c-.25,0-.37-.32-.72-.39-.09,0,0,0-.13,0s0,0-.16-.08c0,.23,0,.17,0,.34a1.22,1.22,0,0,0,.14.59c.06.13.09.09.08.27,0,.35,0,.45.1.74a1.81,1.81,0,0,1,.26.52c.34,0,.29,0,.33.1.32,0,.12-.07.29-.1s.33.08.25-.33c.24.06.12.19.28.17s.06-.12.09-.27-.07,0,.16-.14l0-.29c0-.34.08,0,.19.05l.14-1c0-.08.11-.05-.09-.34C55.48,301,55.61,301,55.56,301Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.65,300.14c0,.13.08.08-.09.09l.19.43c.09,0,.06,0,.19,0,0-.3,0-.19-.1-.34S55.78,300.17,55.65,300.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.24,299.75c-.05.2,0,0-.07.16s-.08.43.21.27C53.38,299.84,53.41,299.87,53.24,299.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.51,296.33a2,2,0,0,0-.59.09c-.35.09-.19.17-.08.34a2.1,2.1,0,0,0,.84-.12c.15,0,.17,0,.08-.17h-.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.29,294a.94.94,0,0,0,0-.16l-.55-.21c-.4-.14-.79-.29-1.17-.44s-.79-.32-1.23-.54-.94-.48-1.42-.78a3.27,3.27,0,0,1-1.18-1.33,3.74,3.74,0,0,1-.26-.67h-.09a2.34,2.34,0,0,0-.53.07l-.5.13a6.34,6.34,0,0,1-1.35.25h-.18l-.51,0-.38,0c-.29,0-.55-.09-.81-.14l-.28-.07-.22.26.14.14a1,1,0,0,1,.21.95,1.46,1.46,0,0,1-1.26.92l-.46,0h-.08a1.52,1.52,0,0,1-1.24-.81,1.08,1.08,0,0,1,.09-1.21l0,0,.2-.3a4.14,4.14,0,0,0,.23-.35l.12-.26a1.64,1.64,0,0,1-1.39-1.05,3.26,3.26,0,0,1-.21-1l-.14,0-.23.05a1,1,0,0,1-.19.21,1.2,1.2,0,0,1-.86.41,1.06,1.06,0,0,1-.34-.06h-.05a1.1,1.1,0,0,1-.64-.2.76.76,0,0,1-.36-.25.83.83,0,0,1-.17-.72,3.07,3.07,0,0,1,.56-1.19s.05-.07.06-.1a1.16,1.16,0,0,1,.34-.68,4,4,0,0,1,.44-.39l.12-.1a1.26,1.26,0,0,1,.24-.19,1.38,1.38,0,0,1,.23-.65,2.46,2.46,0,0,1,.8-.77c.16-.11.33-.2.49-.29l.24-.13.23-.14.12-.08a.77.77,0,0,1,.39-.11.7.7,0,0,1,.31.07.76.76,0,0,1,.42.87l-.25.84a2,2,0,0,1-.35.67c.15.1.34.22.52.36a3.07,3.07,0,0,1,.41.39h.42a3,3,0,0,0,.77-.35l.11-.07a6.11,6.11,0,0,1,1.5-.71,10.33,10.33,0,0,1,2.67-.38h.35c.5,0,1,0,1.45.05a7.44,7.44,0,0,1,1.11.15A6.37,6.37,0,0,1,58.35,285a.51.51,0,0,0-.26-.38c-.14-.06-.07,0-.17-.08l0,0-.11-.09c-.17-.1-.14,0-.21-.23l-.06,0h0c-.11,0-.07-.19-.17-.31s0,.09-.21,0,0,0-.07-.05l-.1,0-.09,0c-.4-.16-.33-.22-.33-.63-.34-.09-.13-.35-.11-.57s-.17-.39-.08-.78c-.48,0-.29-.47-.42-1l0-.47c0-.1,0,0,0-.13l-.13-.07c-.45-.27-.36-.48-.49-.56l-.34.1c-.1.07,0,.05-.15.09-.32-.3-.17-.92-.27-1.32-.05-.17-.08-.4-.31-.46a.87.87,0,0,1,.14-.29c-.11-.06-.17,0-.28-.1a1.4,1.4,0,0,0-.15-.77c-.09-.16,0-.17-.24-.19-.06.23,0,.09-.24.19a1.36,1.36,0,0,1-.18.74v0l0,.06a1,1,0,0,0-.2.47h.15c0,.22,0,.09-.11.23s-.06,0,0,.24-.17.27-.15.54.08.12.07.29,0,.14,0,.27c0,.37.15.27,0,.62s-.11.71-.33,1.07a4.18,4.18,0,0,0-.25.52.71.71,0,0,1-.55.22,2.27,2.27,0,0,1-.49-.25.31.31,0,0,1-.2-.17c-.06-.09,0-.06-.06-.14-.11-.24-.43-.22-.66-.3s-.31-.41-.87-.63l-.29-.09a2.39,2.39,0,0,1-.22-.16l-.19-.2-.23-.17-.2-.12c-.19-.11-.17,0-.17-.27.1,0,.22-.24.32-.36l0-.09.05-.11s0,0,0,0,.07-.18.1-.24c-.2-.08,0,0-.19-.05a.42.42,0,0,0,.1-.2c.25-.12.18,0,.33,0,.29-.42.12-.15.19-.4s.2-.25.29-.41l-.17-.11c-.2-.11-.16.08-.16-.28a.89.89,0,0,0-.39.29c-.05-.06-.05.1-.05-.14a.75.75,0,0,1-.24.09c.14-.18.08,0,.15-.19a1.28,1.28,0,0,0-.63.24c-.13-.08-.2-.08-.25-.24-.24,0-.06,0-.28.1a1,1,0,0,0-.39-.2v-.09c-.26,0-.43.16-.65-.09l-.12-.2c-.18.05-.1.05-.25.14,0-.11-.05-.17-.21-.27s0,0-.1,0l-.27,0s.07,0-.14,0V277c.18,0,0,0,.13.06a.05.05,0,0,1,0,0h0c.14.06.15,0,.38,0a1,1,0,0,1,.09.44l-.35.12h0l-.43.05c-.19,0-.12,0-.19-.18l-.13.06-.12.07c-.15.11.07.05-.17.13-.08,0-.12,0-.22,0s0,.12-.1.28,0,.14-.24.16c0,.35,0,.15.1.38l-.15.06c-.25.06-.13.06-.22.3s-.2.07-.3.51c.15.11.19.11.22.21a.37.37,0,0,1,0,.18c-.46,0-.26,0-.43,0a1.75,1.75,0,0,0-.54-.08c0,.35,0,.11-.1.2l0,0-.07.12c0-.33.07-.1.09-.38-.4-.12-.39-.55-.8-.62s0-.1-.35-.11c-.09.18,0,.22-.2.34,0-.23,0-.07,0-.15s-.1.05-.24.15c0-.22,0-.19-.24-.1,0,.15,0,.1.14.15a.66.66,0,0,0-.1.29l-.28-.24c-.13.24,0,.16-.19.29l-.06,0a.61.61,0,0,0-.14.1c.07.26.13.05,0,.24-.17,0-.18.07-.29.22h0s0,0,0,0a.5.5,0,0,1-.08.07c-.07.07-.15.1-.18.25a.47.47,0,0,0,.12.27c-.1.13-.09.09-.09.29l-.22-.07c-.22-.05-.1.12-.17-.07H39c0,.33-.12.25,0,.39s.18.12.29.28c-.12.05,0,0-.19,0,0,.26.06.09,0,.34-.15-.1-.07-.08-.24-.39s-.18-.1-.15-.43c-.2.06-.19.16-.28.29l-.24.25a.85.85,0,0,0-.19.38c0,.14.08.22.08.48,0,0,0,0,0,0s0,0,.13,0,0,.05-.07.12l-.05.05c-.07.08,0,0-.08.07l-.07.07,0,0-.06,0c-.12.1-.09.11-.15.24l0,.07c-.29.76-.47.76-1.33,1.09-.16,0,0,0-.17,0s-.13-.12-.33,0,0,.11-.19.24-.28-.08-.73.38a.42.42,0,0,1-.3.12c-.25,0-.07-.14-.39.07,0-.25.05-.09-.09-.15,0,.16,0,.13-.16.23-.29.22-.06-.07-.48.4l-.05,0-.15.19,0,.06c-.23.25-.72.14-.72.92h-.14a3.69,3.69,0,0,1,0-.54,1.15,1.15,0,0,0-.34.87c.16.05,0-.08.13.12a.67.67,0,0,1,0,.59.72.72,0,0,0-.09.27v.34c0,.12,0,.08.16.21s0,.18.24.43c0,0,0,0,0,0a1,1,0,0,1,.12.17c.2.25.27.12.27.69h-.1a.78.78,0,0,0-.53-.63c0,.45.12.15.15.49-.11-.08-.05-.06-.19-.1,0,.25,0,.09-.1.15.31.46.8.64.92,1.24.05.27.34.41.44.64s0,0,.07.15l.15.15a.64.64,0,0,1,.17.41c.16,1,.78,1.23.84,1.84v.36c0,.22,0,.18.08.39s0,.29-.07.45a1.19,1.19,0,0,1-.29,0c0,.34,0,.66.3.66s.55.49,1.22.38a2.92,2.92,0,0,0,.73-.09.86.86,0,0,0,.29-.31l0,0,.07-.08s0,0,0-.05l.15-.08c.11,0,.29,0,.34-.17v-.09c.07-.27.46-.27.71-.35l.55-.08h.11c.18,0,0,0,.13,0l.07,0,0,0c.17.07-.12,0,.18.06,0-.11.1-.16.41-.16s.56.15.71-.5a.6.6,0,0,1,.1-.25c.12-.14.2-.07.39-.19.76-.44.47-.52,1.34-.54a2.41,2.41,0,0,0,.92-.28c.57-.23.51-.39,1.4-.39a2,2,0,0,0,.55-.08c.21,0,.64.31.8.41.28-.07.13-.19.47,0a1.64,1.64,0,0,0,.59.13c.06.15,0,0,0,.24.16,0,.16-.06.29,0,0,.11-.09.07-.12.18l.1.28c.12.1.21,0,.33.15s.08.2.26.42a.8.8,0,0,1,.16.47h-.08l-.12.13c.3,0,.22.21.48.27l.1,0s0,0,.1,0l0-.19c0-.15,0-.19.29-.53s.51-.22.64-.47a1.09,1.09,0,0,1,.22-.36c.12-.13,0,0,.1-.14l0,0,0,.06.08.12c-.15,0-.13,0-.2.09.1.22.11.19,0,.32a1.1,1.1,0,0,0-.24.76c0,.28-.07.22-.34.22,0,.18-.08.13-.1.34a.86.86,0,0,0,.34-.1c.21-.05.23.11.34-.14l.2-.58.09.15s0,0,0,0l0,.07v0c.27.55-.18.56-.2.88a1.57,1.57,0,0,0,.48-.09l0,0s0,0,0,0c.29.26.61.59.48,1v.27a.72.72,0,0,0,.2.3l.2.33c.15.16.37.09.54.28l.14.16c.14-.05.14-.11.29-.07l.1,0h.05c.12,0,.06,0,.18.06s.49.27.53.38c.27,0,.79-.69.92-.19.24,0,.25-.17.44-.19l0,.06c-.07.14,0-.08-.07.18l.23.2.07.07.15.06s.06.12.08.2a.24.24,0,0,0,.15-.34c.56,0,.73-.57,1.33-.55.39,0,.7.14,1-.09l.1-.13c.07-.17,0-.22,0-.36l.26-.71a.91.91,0,0,1,.51-.62c.14-.12,0,0,0-.13v0l0-.13a1,1,0,0,1,.26-.46c.28-.23.16-.39.59-.86l.27-.15,0,0,.1-.07C59.42,294.63,59.36,294.29,59.29,294Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,282.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.93,285.82a5.52,5.52,0,0,0-.49-.48,7.2,7.2,0,0,0-.74-.48,1.24,1.24,0,0,0-.38-.14.44.44,0,0,0-.23,0,1.6,1.6,0,0,1,.4-.46,1.44,1.44,0,0,0,.53-.71c.08-.28.16-.56.25-.84l0,0-.37.23c-.24.14-.48.26-.71.41a1.94,1.94,0,0,0-.58.56.87.87,0,0,0-.12.59c0,.14-.06.14-.06.14a.89.89,0,0,0-.43.26c-.17.14-.35.29-.52.45a.53.53,0,0,0-.13.26.69.69,0,0,1-.2.43,2.41,2.41,0,0,0-.42.92c0,.11,0,.16.15.14a.36.36,0,0,0,.39.15s0,0,0,0c.26.12.37.1.61-.13l.16-.18c.11-.18.3-.19.48-.24a1.34,1.34,0,0,0,.59-.24s.14-.11.2,0a1.66,1.66,0,0,1,.23.31,1.42,1.42,0,0,1,.12.46,2.69,2.69,0,0,0,.17.88.94.94,0,0,0,1.1.58,1.91,1.91,0,0,1,.95,0l.19.08-.36,0a.11.11,0,0,0-.12.08c-.17.4-.33.8-.52,1.18s-.31.47-.46.71-.22.31-.12.48a.83.83,0,0,0,.67.47l.49,0a.78.78,0,0,0,.57-.42.28.28,0,0,0-.07-.27c-.05.12-.14.14-.25.15a.71.71,0,0,0-.16.07c0-.11.11-.1.19-.13l0-.21a.1.1,0,0,0-.06,0,.23.23,0,0,1-.32.11l-.13,0c-.15-.05-.17,0-.18.11a.34.34,0,0,0,0,.11.29.29,0,0,1,0-.38c.18-.23.36-.45.56-.66A7.53,7.53,0,0,0,49,288.59a.86.86,0,0,0,.11-.28.57.57,0,0,0-.26-.57,6,6,0,0,0-.69-.41.46.46,0,0,1-.29-.56l.06.18c0,.17.21.22.35.3s.44.21.66.34a.65.65,0,0,1,.21,1.06c-.12.19-.23.38-.34.57s0,.11.06.13c.39.07.77.18,1.16.22a7.55,7.55,0,0,0,1,0,11.33,11.33,0,0,0,1.73-.37,2.68,2.68,0,0,1,1-.06h.07l-.06-.54c0-.15,0-.3,0-.45a3.61,3.61,0,0,0-.35-1.48l-.16-.23a.8.8,0,0,1,.33.3,1.58,1.58,0,0,1,.27.73c.09.44.15.89.22,1.33a5.22,5.22,0,0,0,.4,1.4,2.62,2.62,0,0,0,.91,1c.44.27.9.51,1.37.74s.78.35,1.17.51l1.5.57.71.26a.43.43,0,0,1,.29.28l-.39-.2,0,0c0,.14.09.28.12.42.07.38.14.75.2,1.13s.1.58.14.88,0,.32,0,.49a1,1,0,0,0,.23.67l.15.14a4.91,4.91,0,0,1,.84,1,.93.93,0,0,0,.29.27h.24s0-.06,0-.07a.28.28,0,0,1,0-.37.85.85,0,0,0,.11-.26c0-.16-.08-.27-.16-.39a.94.94,0,0,0-.09-.12l-.2.26h0a.46.46,0,0,0,.07-.52.8.8,0,0,0-.32-.44.78.78,0,0,1-.38-.65c-.05-.34-.08-.68-.12-1a4,4,0,0,1,0-.6c0-.28.06-.57.08-.85a.68.68,0,0,0-.17-.47,3.74,3.74,0,0,0-.79-.58c-.5-.35-1-.69-1.47-1.06A7,7,0,0,1,57,289.45a2.14,2.14,0,0,1-.27-.83,1.36,1.36,0,0,1,.09-.69,3.11,3.11,0,0,0,.16,1.21c.26-.07.5-.17.54-.46a1.79,1.79,0,0,0,0-.51c0-.16.06-.25.22-.22a.84.84,0,0,1,.5.38c.39.59.77,1.2,1.16,1.79.23.37.46.74.71,1.09s.65,1,1,1.42c.19.25.4.48.61.71s.39.4.6.6a7.69,7.69,0,0,0,1.29,1,7.34,7.34,0,0,0,1.86.81,12.87,12.87,0,0,0,1.37.3,6.4,6.4,0,0,0,1.16.07,9.91,9.91,0,0,0,1.22-.15,7,7,0,0,0,1.83-.63c.28-.14.54-.32.81-.49a.12.12,0,0,0,0-.05,1.1,1.1,0,0,0,0-.18.41.41,0,0,0-.15,0c-.15.05-.29.12-.43.18a8,8,0,0,1-1.55.56,6.86,6.86,0,0,1-1.08.21,8,8,0,0,1-1.2,0,5.15,5.15,0,0,1-2-.59A6.56,6.56,0,0,1,64,294l-.46-.44a10,10,0,0,1-1.09-1.33,20.51,20.51,0,0,1-1.16-1.9c-.25-.48-.51-.95-.77-1.42a12.7,12.7,0,0,0-1.25-2,8.92,8.92,0,0,0-1-1.05,5.71,5.71,0,0,0-2.75-1.33,8.46,8.46,0,0,0-1-.14c-.58,0-1.16-.06-1.74,0a9.58,9.58,0,0,0-2.49.34,7.22,7.22,0,0,0-1.45.71,3.53,3.53,0,0,1-1,.44l-.27,0a5.62,5.62,0,0,0-.58,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.31,278.19h-.39v1.1h-.22v-1.1h-.4V278h1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.74,278v1.33h-.23v-.94l-.44.67-.43-.67v.94h-.23V278h.25l.41.64.42-.64Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.28,281.41v.42a3.21,3.21,0,0,0-.76-.4,2.69,2.69,0,0,0-1-.16,2.86,2.86,0,0,0-1.14.22,2.67,2.67,0,0,0-.91.6,2.87,2.87,0,0,0-.59.9,2.7,2.7,0,0,0-.22,1.1,2.89,2.89,0,0,0,.81,2,2.85,2.85,0,0,0,.91.61,3,3,0,0,0,1.14.22h.12a3.14,3.14,0,0,0,1.15-.22v-1.52h0a1.6,1.6,0,0,1-.53.34,1.66,1.66,0,0,1-.62.11l-.27,0h0l-.36-.09a1.38,1.38,0,0,1-.52-.34,1.47,1.47,0,0,1,0-2.17,1.65,1.65,0,0,1,.52-.33,1.68,1.68,0,0,1,.63-.12,1.62,1.62,0,0,1,1.15.45,1.46,1.46,0,0,1,.47,1.09v2.82h1.35v-5.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.56,286.91l-3-2.89v2.89H65.21v-7.62h1.35v2.88l3-2.87h1.91l-4,3.79,4,3.82Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.15,281.27a2.35,2.35,0,0,1,1,.2,2.23,2.23,0,0,1,.77.54,2.4,2.4,0,0,1,.5.81,2.88,2.88,0,0,1,.17,1v3.11H81.24V283.8a1.13,1.13,0,0,0-.39-.88,1.29,1.29,0,0,0-.93-.37,1.26,1.26,0,0,0-.93.37,1.15,1.15,0,0,0-.39.88v3.11H77.25v-5.49H78.6v.4a3.11,3.11,0,0,1,.69-.4A2.35,2.35,0,0,1,80.15,281.27Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.47,281.42a2.38,2.38,0,0,1,.91-.16v1.28a1.62,1.62,0,0,0-1.15.45,1.47,1.47,0,0,0-.47,1.09v2.83H96.4v-5.5h1.36v.41A2.9,2.9,0,0,1,98.47,281.42Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.44,281.27a3,3,0,0,1,1.16.22,2.8,2.8,0,0,1,.94.6,2.85,2.85,0,0,1,.64.9,2.71,2.71,0,0,1,.23,1.1,2.72,2.72,0,0,1-.87,2,3,3,0,0,1-.94.61,3.19,3.19,0,0,1-1.16.22,3.15,3.15,0,0,1-1.16-.22,3,3,0,0,1-1-.61,2.78,2.78,0,0,1-.64-.9,2.66,2.66,0,0,1-.23-1.09,2.71,2.71,0,0,1,.23-1.1,3,3,0,0,1,.64-.9,2.84,2.84,0,0,1,1-.6A3,3,0,0,1,102.44,281.27Zm0,1.28a1.6,1.6,0,0,0-1.15.45,1.49,1.49,0,0,0,0,2.17,1.38,1.38,0,0,0,.52.34,1.67,1.67,0,0,0,.63.11,1.62,1.62,0,0,0,.62-.11,1.6,1.6,0,0,0,.53-.34,1.49,1.49,0,0,0,0-2.17A1.67,1.67,0,0,0,102.44,282.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.76,281.27a3,3,0,0,1,1.16.22,2.84,2.84,0,0,1,1,.6,3,3,0,0,1,.64.9,2.71,2.71,0,0,1,.23,1.1,2.66,2.66,0,0,1-.23,1.09,2.78,2.78,0,0,1-.64.9,3,3,0,0,1-1,.61,3.15,3.15,0,0,1-1.16.22,3.19,3.19,0,0,1-1.16-.22,3,3,0,0,1-.94-.61,2.72,2.72,0,0,1-.87-2A2.71,2.71,0,0,1,106,283a2.85,2.85,0,0,1,.64-.9,2.8,2.8,0,0,1,.94-.6A3,3,0,0,1,108.76,281.27Zm0,1.28a1.62,1.62,0,0,0-1.15.45,1.49,1.49,0,0,0,0,2.17,1.42,1.42,0,0,0,.53.34,1.66,1.66,0,0,0,.62.11,1.59,1.59,0,0,0,.62-.11,1.58,1.58,0,0,0,1-1.42,1.43,1.43,0,0,0-.48-1.09A1.65,1.65,0,0,0,108.76,282.55Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.3,281.41v.42a3.14,3.14,0,0,0-.75-.4,2.72,2.72,0,0,0-1-.16,2.86,2.86,0,0,0-1.14.22,2.58,2.58,0,0,0-.91.6,2.73,2.73,0,0,0-.6.9,2.87,2.87,0,0,0-.21,1.1,2.82,2.82,0,0,0,.21,1.09,2.54,2.54,0,0,0,.6.9,2.75,2.75,0,0,0,.91.61,3,3,0,0,0,1.14.22h.11a3.19,3.19,0,0,0,1.16-.22v-1.52h0a1.5,1.5,0,0,1-.53.34,1.59,1.59,0,0,1-.62.11l-.26,0h0a2.11,2.11,0,0,1-.36-.09,1.42,1.42,0,0,1-.53-.34,1.49,1.49,0,0,1,0-2.17,1.69,1.69,0,0,1,.53-.33,1.63,1.63,0,0,1,.62-.12,1.6,1.6,0,0,1,1.15.45,1.42,1.42,0,0,1,.47,1.09v2.82h1.36v-5.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.75,281.41h0v.41a3.34,3.34,0,0,0-.75-.4,2.52,2.52,0,0,0-.49-.13,3.6,3.6,0,0,0-.58,0,2.73,2.73,0,0,0-1.12.22,2.38,2.38,0,0,0-.88.6,2.65,2.65,0,0,0-.57.9,2.87,2.87,0,0,0-.21,1.1h0a2.83,2.83,0,0,0,.22,1.09,2.54,2.54,0,0,0,.6.9,2.7,2.7,0,0,0,.9.61,3.06,3.06,0,0,0,1.15.22h.19a3.13,3.13,0,0,0,1.07-.21v-1.52h0a1.6,1.6,0,0,1-.53.34,1.62,1.62,0,0,1-.62.11l-.26,0h0a2.22,2.22,0,0,1-.37-.09,1.38,1.38,0,0,1-.52-.34,1.45,1.45,0,0,1-.47-1.08,1.32,1.32,0,0,1,.11-.57l0,0A1.52,1.52,0,0,1,85,283a1.65,1.65,0,0,1,.52-.33,1.68,1.68,0,0,1,.63-.12,1.62,1.62,0,0,1,1.15.45,1.52,1.52,0,0,1,.34.47l0,0a1.56,1.56,0,0,1,.11.57v2.14a1.45,1.45,0,0,1-.47,1.08,1.55,1.55,0,0,1-1.15.46,1.58,1.58,0,0,1-.81-.21l-1,.92a2.85,2.85,0,0,0,.83.43,3.1,3.1,0,0,0,3.07-.69,2.61,2.61,0,0,0,.63-.9,2.51,2.51,0,0,0,.23-1.09v-4.81H87.75Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.78,291.56v.36H65.21v-2.05h1.51v.36H65.61v.52h.93v.35h-.93v.46Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.37,289.7v2.19H69v-.09a.94.94,0,0,1-.45.12.79.79,0,0,1-.8-.82.78.78,0,0,1,.8-.81.87.87,0,0,1,.45.12v-.71ZM69,291.42v-.64a.58.58,0,0,0-.38-.13.45.45,0,0,0-.47.45.44.44,0,0,0,.47.45A.58.58,0,0,0,69,291.42Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72,290.32v1.57h-.4v-.1a.78.78,0,0,1-.43.13c-.47,0-.68-.22-.68-.73v-.87h.41v.87c0,.25.11.37.34.37a.57.57,0,0,0,.36-.13v-1.11Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.43,291.6a.74.74,0,0,1-.61.32.82.82,0,1,1,0-1.63.76.76,0,0,1,.62.31l-.26.24a.45.45,0,0,0-.36-.19.46.46,0,1,0,0,.91.43.43,0,0,0,.36-.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77,290.32v1.57h-.4v-.11a.81.81,0,0,1-.46.14.79.79,0,0,1-.79-.82.78.78,0,0,1,.79-.81.94.94,0,0,1,.46.13v-.1Zm-.4.47a.58.58,0,0,0-.39-.14.46.46,0,1,0,0,.91.58.58,0,0,0,.39-.14Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.6,290.65v.56c0,.28.05.36.25.36H79v.3a.91.91,0,0,1-.37.06.45.45,0,0,1-.47-.5v-.77H78v-.33h.23v-.61h.4v.61h.45v.33Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80,289.93a.23.23,0,0,1,.46,0,.23.23,0,1,1-.46,0Zm0,.41h.41v1.58H80Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.19,291.11a.86.86,0,1,1-.86-.82A.83.83,0,0,1,83.19,291.11Zm-.4,0a.46.46,0,1,0-.46.45A.46.46,0,0,0,82.79,291.11Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.71,291v.88H85.3V291c0-.25-.12-.36-.34-.36a.51.51,0,0,0-.35.12v1.12h-.4v-1.58h.4v.1a.75.75,0,0,1,.42-.13C85.49,290.31,85.71,290.53,85.71,291Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.87,290.23V291h1v.36h-1v.6h-.4v-2.05H90v.36Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.62,291.11a.86.86,0,1,1-.86-.82A.84.84,0,0,1,92.62,291.11Zm-.4,0a.46.46,0,0,0-.46-.46.46.46,0,1,0,0,.91A.46.46,0,0,0,92.22,291.11Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.13,290.32v1.57h-.41v-.1a.75.75,0,0,1-.43.13c-.46,0-.67-.22-.67-.73v-.87H94v.87c0,.25.12.37.35.37a.52.52,0,0,0,.35-.13v-1.11Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.72,291v.88h-.41V291c0-.25-.12-.36-.34-.36a.51.51,0,0,0-.35.12v1.12h-.4v-1.58h.4v.1a.75.75,0,0,1,.42-.13C97.5,290.31,97.72,290.53,97.72,291Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.38,289.7v2.19H100v-.09a1,1,0,0,1-.46.12.79.79,0,0,1-.8-.82.78.78,0,0,1,.8-.81.9.9,0,0,1,.46.12v-.71Zm-.4,1.72v-.64a.63.63,0,0,0-.39-.13.45.45,0,0,0-.47.45.44.44,0,0,0,.47.45A.63.63,0,0,0,100,291.42Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.05,290.32v1.57h-.4v-.11a.81.81,0,0,1-.46.14.79.79,0,0,1-.79-.82.78.78,0,0,1,.79-.81.91.91,0,0,1,.46.13v-.1Zm-.4.47a.58.58,0,0,0-.39-.14.45.45,0,0,0-.47.45.46.46,0,0,0,.47.46.58.58,0,0,0,.39-.14Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.64,290.65v.56c0,.28,0,.36.25.36h.18v.3a.88.88,0,0,1-.36.06.46.46,0,0,1-.48-.5v-.77H104v-.33h.22v-.61h.41v.61h.44v.33Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,289.93a.23.23,0,0,1,.23-.23.23.23,0,0,1,.23.23.23.23,0,0,1-.23.24A.23.23,0,0,1,106,289.93Zm0,.41h.41v1.58h-.41Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.22,291.11a.86.86,0,1,1-.86-.82A.83.83,0,0,1,109.22,291.11Zm-.39,0a.47.47,0,1,0-.47.45A.47.47,0,0,0,108.83,291.11Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.74,291v.88h-.41V291c0-.25-.11-.36-.34-.36a.51.51,0,0,0-.35.12v1.12h-.4v-1.58h.4v.1a.77.77,0,0,1,.42-.13C111.53,290.31,111.74,290.53,111.74,291Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.74,295.52v.36H73.17v-2.05h1.51v.36H73.57v.52h.93v.35h-.93v.46Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.62,293.68v2.2h-.41v-.1a.91.91,0,0,1-.46.13.79.79,0,0,1-.8-.82.78.78,0,0,1,.8-.82,1,1,0,0,1,.46.12v-.71Zm-.41,1.72v-.63a.64.64,0,0,0-.39-.14.45.45,0,0,0-.47.46.44.44,0,0,0,.47.45A.58.58,0,0,0,76.21,295.4Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.47,294.3v1.58h-.4v-.1a.77.77,0,0,1-.43.12c-.46,0-.68-.21-.68-.72v-.88h.41v.88c0,.24.12.36.34.36a.53.53,0,0,0,.36-.13V294.3Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.24,295.59a.77.77,0,0,1-.61.31.82.82,0,1,1,0-1.63.79.79,0,0,1,.62.31l-.27.25a.42.42,0,0,0-.35-.2.47.47,0,0,0-.47.46.46.46,0,0,0,.47.45.42.42,0,0,0,.35-.2Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.11,294.3v1.58H81.7v-.12a.81.81,0,1,1-.46-1.49.88.88,0,0,1,.46.13v-.1Zm-.41.47a.64.64,0,0,0-.39-.14.46.46,0,1,0,0,.91.61.61,0,0,0,.39-.13Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83,294.63v.56c0,.29,0,.37.25.37l.19,0v.31a1.37,1.37,0,0,1-.37,0,.45.45,0,0,1-.48-.49v-.78h-.22v-.33h.22v-.62H83v.62h.44v.33Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.65,293.89a.24.24,0,0,1,.23-.24.24.24,0,0,1,0,.48A.24.24,0,0,1,83.65,293.89Zm0,.41h.41v1.58h-.41Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.12,295.09a.84.84,0,0,1-.87.81.82.82,0,1,1,0-1.63A.84.84,0,0,1,86.12,295.09Zm-.4,0a.47.47,0,0,0-.94,0,.47.47,0,0,0,.94,0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.91,295v.88h-.4V295c0-.25-.12-.37-.35-.37a.52.52,0,0,0-.35.13v1.12h-.4V294.3h.4v.1a.75.75,0,0,1,.42-.13C87.7,294.27,87.91,294.49,87.91,295Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91,295a3.12,3.12,0,0,1-.31.47l.25.24-.24.22-.23-.22a.87.87,0,0,1-.55.22c-.47,0-.77-.22-.77-.59a.61.61,0,0,1,.43-.55.57.57,0,0,1-.18-.4.54.54,0,0,1,.58-.56.53.53,0,0,1,.58.52.63.63,0,0,1-.44.56l.35.33a1.93,1.93,0,0,0,.24-.33Zm-.74.48-.46-.45c-.17.07-.25.17-.25.29s.14.29.39.29A.48.48,0,0,0,90.22,295.45Zm-.52-1.08a.43.43,0,0,0,.18.3c.13-.05.3-.14.3-.3a.24.24,0,0,0-.24-.27A.26.26,0,0,0,89.7,294.37Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.68,293.83h.45l-1,2.05H93l-1-2.05h.45l.6,1.34Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.31,293.89a.24.24,0,1,1,.24.24A.24.24,0,0,1,94.31,293.89Zm0,.41h.4v1.58h-.4Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.19,295.45a1.23,1.23,0,0,0,.55.13c.18,0,.25-.07.25-.15s-.09-.13-.33-.18-.59-.19-.59-.5.24-.48.6-.48a1.58,1.58,0,0,1,.62.13l-.13.29a1.78,1.78,0,0,0-.49-.1c-.16,0-.24.06-.24.14s.1.13.35.18.58.21.58.5-.23.49-.63.49a1.32,1.32,0,0,1-.69-.15Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.23,294.3v1.58h-.4v-.12a.81.81,0,0,1-.46.14.82.82,0,0,1,0-1.63.91.91,0,0,1,.46.13v-.1Zm-.4.47a.64.64,0,0,0-.39-.14.46.46,0,1,0,0,.91.63.63,0,0,0,.39-.13Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.12,295.28c0,.39-.32.63-.8.63a1.62,1.62,0,0,1-.85-.2l.15-.32a1.48,1.48,0,0,0,.72.16c.22,0,.36-.09.36-.24s-.14-.2-.44-.27-.76-.21-.76-.62.29-.62.75-.62a1.93,1.93,0,0,1,.79.17l-.17.33a1.92,1.92,0,0,0-.62-.14c-.21,0-.33.1-.33.23s.15.2.45.27S101.12,294.9,101.12,295.28Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.75,295.2a.44.44,0,0,0,.45.36.51.51,0,0,0,.41-.2l.26.22a.88.88,0,0,1-.72.32.82.82,0,0,1,0-1.63.75.75,0,0,1,.77.84v.09Zm0-.25h.79a.35.35,0,0,0-.39-.36A.42.42,0,0,0,101.75,295Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.62,294.52a.59.59,0,0,1,.5-.25l.1,0v.44a.91.91,0,0,0-.2,0,.38.38,0,0,0-.4.42v.76h-.41V294.3h.41Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.06,294.3l-.76,1.58h-.19l-.76-1.58h.42l.43.9.43-.9Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.26,293.89a.24.24,0,1,1,.24.24A.24.24,0,0,1,106.26,293.89Zm0,.41h.4v1.58h-.4Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.48,295.59a.78.78,0,0,1-.61.31.82.82,0,1,1,0-1.63.75.75,0,0,1,.61.31l-.26.25a.43.43,0,0,0-.35-.2.47.47,0,0,0-.47.46.46.46,0,0,0,.47.45.43.43,0,0,0,.35-.2Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109,295.2a.44.44,0,0,0,.45.36.5.5,0,0,0,.41-.2l.26.22a.85.85,0,0,1-.71.32.82.82,0,0,1,0-1.63.76.76,0,0,1,.77.84s0,.07,0,.09Zm0-.25h.78a.35.35,0,0,0-.38-.36A.41.41,0,0,0,109.05,295Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.57,295.45a1.19,1.19,0,0,0,.54.13c.19,0,.26-.07.26-.15s-.09-.13-.33-.18-.59-.19-.59-.5.23-.48.6-.48a1.58,1.58,0,0,1,.62.13l-.14.29a1.64,1.64,0,0,0-.49-.1c-.15,0-.23.06-.23.14s.1.13.35.18.58.21.58.5-.23.49-.64.49a1.31,1.31,0,0,1-.68-.15Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 567.05,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 319.02,
    x2: 567.05,
    y2: 319.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 319.02
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 319.02,
    y1: 0.13,
    x2: 319.02,
    y2: 319.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 32.01,
    y1: 0.13,
    x2: 32.01,
    y2: 319.02
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 63.9,
    y1: 0.13,
    x2: 63.9,
    y2: 319.02
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 95.79,
    y1: 0.13,
    x2: 95.79,
    y2: 319.02
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 127.68,
    y1: 0.13,
    x2: 127.68,
    y2: 319.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 159.57,
    y1: 0.13,
    x2: 159.57,
    y2: 319.02
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191.46,
    y1: 0.13,
    x2: 191.46,
    y2: 319.02
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 223.35,
    y1: 0.13,
    x2: 223.35,
    y2: 319.02
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 255.24,
    y1: 0.13,
    x2: 255.24,
    y2: 319.02
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 287.13,
    y1: 0.13,
    x2: 287.13,
    y2: 319.02
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.07,
    y1: 0.13,
    x2: 16.07,
    y2: 319.02
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 47.96,
    y1: 0.13,
    x2: 47.96,
    y2: 319.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 79.85,
    y1: 0.13,
    x2: 79.85,
    y2: 319.02
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 111.74,
    y1: 0.13,
    x2: 111.74,
    y2: 319.02
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 143.63,
    y1: 0.13,
    x2: 143.63,
    y2: 319.02
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 175.52,
    y1: 0.13,
    x2: 175.52,
    y2: 319.02
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 207.41,
    y1: 0.13,
    x2: 207.41,
    y2: 319.02
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 239.3,
    y1: 0.13,
    x2: 239.3,
    y2: 319.02
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 271.19,
    y1: 0.13,
    x2: 271.19,
    y2: 319.02
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 303.08,
    y1: 0.13,
    x2: 303.08,
    y2: 319.02
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 287.13,
    x2: 567.05,
    y2: 287.13
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 255.24,
    x2: 567.05,
    y2: 255.24
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 223.35,
    x2: 567.05,
    y2: 223.35
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 191.46,
    x2: 567.05,
    y2: 191.46
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 159.57,
    x2: 567.05,
    y2: 159.57
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 127.68,
    x2: 567.05,
    y2: 127.68
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 95.79,
    x2: 567.05,
    y2: 95.79
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 63.9,
    x2: 567.05,
    y2: 63.9
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 32.01,
    x2: 567.05,
    y2: 32.01
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 303.08,
    x2: 567.05,
    y2: 303.08
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 271.19,
    x2: 567.05,
    y2: 271.19
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 239.3,
    x2: 567.05,
    y2: 239.3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 207.41,
    x2: 567.05,
    y2: 207.41
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 175.52,
    x2: 567.05,
    y2: 175.52
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 143.63,
    x2: 567.05,
    y2: 143.63
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 111.74,
    x2: 567.05,
    y2: 111.74
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 79.85,
    x2: 567.05,
    y2: 79.85
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 47.96,
    x2: 567.05,
    y2: 47.96
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 16.07,
    x2: 567.05,
    y2: 16.07
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 350.91,
    y1: 0.13,
    x2: 350.91,
    y2: 319.02
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 382.8,
    y1: 0.13,
    x2: 382.8,
    y2: 319.02
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 414.69,
    y1: 0.13,
    x2: 414.69,
    y2: 319.02
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 446.58,
    y1: 0.13,
    x2: 446.58,
    y2: 319.02
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 478.47,
    y1: 0.2,
    x2: 478.47,
    y2: 319.09
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 334.97,
    y1: 0.13,
    x2: 334.97,
    y2: 319.02
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 366.86,
    y1: 0.13,
    x2: 366.86,
    y2: 319.02
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 398.75,
    y1: 0.13,
    x2: 398.75,
    y2: 319.02
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 430.64,
    y1: 0.13,
    x2: 430.64,
    y2: 319.02
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 462.53,
    y1: 0.13,
    x2: 462.53,
    y2: 319.02
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 510.36,
    y1: 0.13,
    x2: 510.36,
    y2: 319.02
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 542.25,
    y1: 0.13,
    x2: 542.25,
    y2: 319.02
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 494.42,
    y1: 0.13,
    x2: 494.42,
    y2: 319.02
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 526.31,
    y1: 0.13,
    x2: 526.31,
    y2: 319.02
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 558.2,
    y1: 0.13,
    x2: 558.2,
    y2: 319.02
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(0.13 336.16)"
  }, "Size: 16:9")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 318.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial9);
export default __webpack_public_path__ + "static/media/guideMaterial9.5033f0350b3bfe6f2f39ad085549ef20.svg";
export { ForwardRef as ReactComponent };